__turbopack_context__.v({
  "auth": "auth-module-scss-module__OAX0Kq__auth",
  "flowSwitcher": "auth-module-scss-module__OAX0Kq__flowSwitcher",
  "question": "auth-module-scss-module__OAX0Kq__question",
});
